/* fx-diagram.js: the two things the parts diagram popup needs that CSS cannot do.
   1. A thumbnail per row. The extension renders the parts list as a table with
      no image in it, but it holds the product objects that carry one, so the
      picture is read off those and injected as an extra cell.
   2. Shorter wording on the enlarge control, which is now a corner button
      rather than a bar across the drawing.
   Nothing here is stamped and trusted. The extension rebuilds these rows
   whenever it likes and leaves attributes behind, so every pass checks that
   what it built is still there and rebuilds it if not. */
(function () {
  "use strict";

  var frame = 0;

  function parts() {
    var host = document.querySelector("vin-search-modal");
    var list = host && host._diagramExpandParts;
    return Array.isArray(list) ? list : null;
  }

  function fill(cell, src, alt) {
    var img = cell.firstElementChild;
    if (!src) {
      if (img) cell.removeChild(img);
      return;
    }
    if (!img || img.tagName !== "IMG") {
      if (img) cell.removeChild(img);
      img = document.createElement("img");
      img.loading = "lazy";
      img.decoding = "async";
      img.draggable = false;
      cell.appendChild(img);
    }
    /* Compare before writing: setting the same src back on every pass
       re-requests nothing but does invalidate layout for free. */
    if (img.getAttribute("src") !== src) img.setAttribute("src", src);
    if (img.getAttribute("alt") !== alt) img.setAttribute("alt", alt);
  }

  function thumbs() {
    var overlay = document.getElementById("vinDiagramExpand");
    if (!overlay || overlay.hidden) return;
    var list = parts();
    if (!list) return;
    var rows = overlay.querySelectorAll(".vin-diagram-expand__row");
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var num = row.querySelector(".vin-diagram-expand__cell-num");
      if (!num) continue;
      var cell = row.querySelector(".fxd-img");
      if (!cell) {
        cell = document.createElement("td");
        cell.className = "fxd-img";
        num.insertAdjacentElement("afterend", cell);
      }
      var p = list[i] || {};
      fill(cell, p.image || "", p.imageAlt || p.title || "");
    }
  }

  /* "Click to enlarge" was written for a bar the width of the drawing. In a
     corner button the verb is the whole message. */
  function hint() {
    var el = document.querySelector(".vin-diagram-expand__image-hint");
    if (el && /click to enlarge/i.test(el.textContent || "")) el.textContent = "Enlarge";
  }

  function tick() {
    frame = 0;
    thumbs();
    hint();
  }

  function schedule() {
    if (frame) return;
    frame = setTimeout(tick, 40);
  }

  function start() {
    tick();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["hidden", "class"]
    });
    /* The observer covers every render the extension does. The interval is the
       safety net for anything that lands without a DOM mutation, and it is slow
       enough to cost nothing. */
    setInterval(tick, 900);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
